import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { toast } from "react-toastify";

import Area from "../../aGlobalDesign/Area/Area";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import ButtonSKA from "../../aGlobalDesign/Buttons/ButtonSKA";
import PaginationList from "../../aGlobalDesign/Pagination/PaginationList";
import EditTags from "../../aGlobalDesign/Tags/EditTags";
import UploadManager from "../../aGlobalDesign/UploadManager/UploadManager";
import DropArea from "../../aGlobalDesign/Area/DropArea";

class ImportFiles extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            contentGroup: null,
            showLoader: false,
            files: [],
            filesTable: [],
            tagsToAdd: [],
            tagsToCreate: [],

            unsupportedFileFormat: false
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.ImportFiles);
        if (this.props.location.state) {
            this.handleChange(this.props.location.state);
        }
        this.props.GetAllTags();
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            tempEditContent: null,
            forcePaginationUpdate: temp
        });
    }

    //#region functions
    onChangeGroup(value) {
        this.setState({
            contentGroup: value
        });
    }

    handleChange(inputFiles) {
        const filesTable = this.state.filesTable;
        const files = this.state.files;
        for (let i = 0; i < inputFiles.length; i++) {
            if (!(inputFiles[i].type.indexOf("pdf") > -1
            || inputFiles[i].type.indexOf("image/") > -1
            || inputFiles[i].type.indexOf("video/") > -1
            ) || inputFiles[i].type.indexOf("image/webp") > -1) {
                this.setState({ showLoader: false });
                this.setState({ unsupportedFileFormat: true });
                return;
            }
            if (inputFiles[i].size > this.props.configuration.multipartBodyLengthLimit) {
                this.setState({ showLoader: false });
                this.props.OpenDialog({
                    title: strings.fileTooBig,
                    description: strings.fileTooBigDesc + this.props.configuration.multipartBodyLengthLimit / 1000000 + "MB",
                    primaryLabel: "OK",
                    clickOutsideToClose: true
                });
                return false;
            }
            files.push(inputFiles[i]);
            filesTable.push({
                name: inputFiles[i].name,
                size: this.convertBytes(inputFiles[i].size),
                type: inputFiles[i].type
            });
        }

        this.setState({
            showLoader: false,
            files: files,
            filesTable: filesTable
        });
        //this.forcePaginationUpdate();
        () => this.inputFiles.click();
    }

    addFiles(inputFiles) {
        const filesTable = this.state.filesTable;
        const files = this.state.files;
        for (let i = 0; i < inputFiles.length; i++) {
            if (!(inputFiles[i].type.indexOf("pdf") > -1
            || inputFiles[i].type.indexOf("image/") > -1
            || inputFiles[i].type.indexOf("video/") > -1
            ) || inputFiles[i].type.indexOf("image/webp") > -1) {
                this.setState({ showLoader: false });
                this.setState({ unsupportedFileFormat: true });
                return;
            }
            if (inputFiles[i].size > this.props.configuration.multipartBodyLengthLimit) {
                this.setState({ showLoader: false });
                this.props.OpenDialog({
                    title: strings.fileTooBig,
                    description: strings.fileTooBigDesc + this.props.configuration.multipartBodyLengthLimit / 1000000 + "MB",
                    primaryLabel: "OK",
                    clickOutsideToClose: true
                });
                return false;
            }

            if (!files.some(e => e.name === inputFiles[i].name)) {
                files.push(inputFiles[i]);
            }

            if (!filesTable.some(e => e.name === inputFiles[i].name)) {
                filesTable.push({
                    name: inputFiles[i].name,
                    size: this.convertBytes(inputFiles[i].size),
                    type: inputFiles[i].type
                });
            }
        }

        this.setState({
            showLoader: false,
            files: files,
            filesTable: filesTable
        });
        //this.forcePaginationUpdate();
    }

    convertBytes(fileSize) {
        let size = fileSize / 1000;
        if (size > 1000) {
            size = parseInt(size / 1000);
            size += " MB";
        }
        else {
            size = parseInt(size);
            size += " KB";
        }

        return size;
    }

    onRemoveFile(file) {
        const filesTable = this.state.filesTable;
        const files = this.state.files;
        const index = filesTable.indexOf(file);
        filesTable.splice(index, 1);
        files.splice(index, 1);
        this.setState({ filesTable, files });
        //this.forcePaginationUpdate();
    }

    onSave() {
        const contentGroup = null;
        this.props.CreateContents(this.state.files, contentGroup, this.state.tagsToAdd, this.state.tagsToCreate, () => {
            toast.success(strings.successfullSave);
            this.props.history.push("/Resources/ContentsList");
        });
    }

    onClose() {
        this.props.history.push("/Resources/ContentsList");
    }
    //#endregion

    render() {

        return <>
            <input
                ref={(input) => { this.fileInput = input; }}
                type="file"
                accept="image/jpg, image/jpeg, image/png, video/mp4"
                onChange={ (e) => {
                    for (let i = 0; i < e.target.files.length; i++) {
                        if (!(e.target.files[i].type.indexOf("pdf") > -1
                                || e.target.files[i].type.indexOf("image/") > -1
                                || e.target.files[i].type.indexOf("video/") > -1
                        ) || e.target.files[i].type.indexOf("image/webp") > -1) {
                            this.setState({ showLoader: false });
                            this.setState({ unsupportedFileFormat: true });
                            return;
                        }
                        else {
                            this.addFiles(e.target.files);
                        }
                    }
                }}
                style={{ display: "none" }}
                multiple
            />
            <Area
                helmet={strings.ImportFiles}
                title={strings.ImportFilesTitle}
                leftButton={<ButtonSkaRound
                    type="secondary"
                    onClick={() => this.onClose()}
                    nameIcon="chevronLeft"
                />}
                sideButtons={this.state.filesTable.length > 0 ? [
                    {
                        type: "primary-icon",
                        nameIcon: "check",
                        text: strings.confirmUpload,
                        onClick: () => this.onSave()
                    }
                ] : null}
            >
                <DropArea handleDrop={this.handleChange.bind(this)} />
                <div style={{
                    display: this.state.filesTable.length > 0 ? "flex" : "none",
                    flexDirection: "column", gap: "20px", height: "100%", width: "100%"
                }}>
                    <PaginationList
                        forcePaginationUpdate={this.state.forcePaginationUpdate}
                        pageSize={100}

                        onGetElements={
                            (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => {
                                setTimeout(() => {
                                    onSuccess({
                                        pageNumber: pageNumber,
                                        pageSize: pageSize,
                                        sortExpression: sortExpression,
                                        filterExpression: filterExpression,
                                        tagSearchRequest: tagSearchRequest,
                                        PaginationType: PaginationType,
                                        results: this.state.filesTable
                                    });
                                }, 500);
                            }}
                        onSavePagination={(paginationType) => {}}
                        myElements={{ results: this.state.filesTable }}

                        tableElement={(element) => {
                            return [
                                {
                                    colTitle: strings.SortName,
                                    colContent: element ? element.name : null,
                                    fixedWidth: "300px"
                                },
                                {
                                    colTitle: strings.SortContentType,
                                    colContent: element ? element.type : null,
                                    fixedWidth: "200px"
                                },
                                {
                                    colTitle: strings.SortSize,
                                    fixedWidth: "200px",
                                    lockWidth: true,
                                    colContent: element ? element.size : null
                                },
                                {
                                    colTitle: "",
                                    colType: "actions",
                                    actions: [0],
                                    colContent: [
                                        <ButtonSkaRound
                                            key={"trash"}
                                            type="primary"
                                            onClick={() => {this.onRemoveFile(element);}}
                                            nameIcon="trash"
                                        />
                                    ]
                                }
                            ];
                        }}
                    />
                    <div style={{
                        display: "flex",
                        width: "calc(100% - 40px)",
                        gap: "20px",
                        justifyContent: "center",
                        padding: "20px",
                        borderRadius: "10px",
                        backgroundColor: "var(--white)" }}>
                        <EditTags
                            allTags={this.props.dictionaries.tags}
                            elementTags={[...this.state.tagsToAdd, ...this.state.tagsToCreate]}
                            onChangeTags={(newList) => {
                                const tagsToAdd = newList.filter(tag => tag.id !== 0);
                                const tagsToCreate = newList.filter(tag => tag.id === 0);
                                this.setState({
                                    tagsToAdd: tagsToAdd,
                                    tagsToCreate: tagsToCreate
                                });
                            }}/>
                    </div>
                </div>
                <div className={"verticalFlexContainer"}
                    style={{
                        display: this.state.filesTable.length <= 0 ? "flex" : "none",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "10px",
                        flex: 1,
                        gap: "20px",
                        background: "var(--white)",
                        height: "100%"
                    }}>
                    <div style={{ fontWeight: "700", fontSize: "24px" }}>{strings.dropYourFiles}</div>
                    <div>{strings.or}</div>
                    <ButtonSKA
                        type="primary-icon"
                        onClick={() => {
                            this.fileInput.click();
                        }}
                        nameIcon="folder"
                        text={strings.browse}
                    />
                </div>
            </Area>
            {
                <UploadManager
                    open={this.props.uploadManager.isOpen}
                    inProgressFiles={Object.values(this.props.uploadManager)[3]}
                    doneFiles={Object.values(this.props.uploadManager)[4]}
                    queueFiles={Object.values(this.props.uploadManager)[2]}
                    uploadManagerprogress={this.props.uploadManager.progress}
                />
            }
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(ImportFiles);
